import { Bot } from 'lucide-react';
import { useSew } from '../lib/sewStore';

const n1 = (v, d = 2) => (v == null || !Number.isFinite(+v) ? '–' : (+v).toFixed(d).replace('.', ','));

// rule-based hint from the SWMM result (no AI call): blockage, backwater, overload, surcharge or ok
function hint(t, n, out, bl) {
  if (n.flood && bl > 0) return t.swHintBlock.replace('{p}', bl);
  if (n.flood && out.some((l) => l.df >= 0.99 && l.qf < 0.6)) return t.swHintBack;
  if (n.flood) return t.swHintOver;
  if (n.sur?.h > 0) return t.swHintSur;
  return t.swHintOk;
}

// manhole card in the object sheet: water level, freeboard, surcharge / flooding of the last sewer run + Stormy hint
export function SewNodeCard({ t, obj }) {
  const s = useSew(), r = s.res, n = r && !r.error && r.nodes?.[obj.id];
  if (!n) return null;
  // SWMM keeps rising the head above the rim while water floods out: on site the water stands at the cover
  const rim = +String(obj.elev?.v ?? '').replace(',', '.'), hasRim = Number.isFinite(rim), over = hasRim && n.hgl != null && n.hgl > rim;
  const wl = over ? rim : n.hgl, fb = hasRim && wl != null ? rim - wl : null, fl = n.flood && n.flood.vol > 0.05;
  const out = Object.values(r.links || {}).filter((l) => l.a === obj.id), bl = +((r.blocked || {})[obj.id] || 0);
  return (
    <div className="sew-card" data-testid="sew-node-card">
      <b>🌧️ {t.swCard}</b>
      <div className="sew-card-grid">
        <span>{t.swCardHgl}</span><b data-testid="sew-card-hgl">{n1(wl)} m{over ? ` (${t.swCardAtRim})` : ''}</b>
        <span>{t.swCardRim}</span><b>{n1(hasRim ? rim : null)} m</b>
        <span>{t.swCardFb}</span><b data-testid="sew-card-freeboard" className={fb != null && fb <= 0.05 ? 'bad' : ''}>{n1(fb)} m</b>
        <span>{t.swCardDepth}</span><b>{n1(n.maxD)} m</b>
        {n.sur?.h > 0 && <><span>{t.swCardSur}</span><b>{n1(n.sur.h, 1)} h</b></>}
        {fl && <><span>{t.swCardFlood}</span><b data-testid="sew-card-flood" className="bad">{n1(n.flood.vol, 1)} m³ · {n1(n.flood.q, 1)} l/s</b></>}
        {bl > 0 && <><span>{t.swCardBlock}</span><b className="bad">{bl} %</b></>}
      </div>
      <p className="sew-card-hint" data-testid="sew-card-hint">💬 Stormy: {hint(t, { ...n, flood: fl && n.flood }, out, bl)}</p>
      <small className="muted">{t.swCardSrc}</small>
      <button className="btn btn-outline btn-sm" data-testid="sew-card-ask-btn" onClick={() => window.dispatchEvent(new Event('giss-agent-open'))}><Bot size={14} /> {t.swCardAsk}</button>
    </div>
  );
}
